module.exports = __webpack_public_path__ + "img/tb-06@2x.5807c005.png";